angular.module('iqxCore')
  .controller('AuthCallbackCtrl', function ($scope, authSvc, $location, ApplicationSvc, ApiSvc, loginSvc, $timeout) {
    $timeout(function () {
      authSvc.getProfile(function (err, profile) {
        if(localStorage.getItem('personid_from_auth0') && !profile.person_id) {
          $scope.isLoading = false
          return $scope.loginerr = "PersonID Missing from Auth0."
        }
        if(!profile.person_id && !localStorage.getItem('personid')) {
          $scope.isLoading = false
          return $scope.loginerr = "PersonID Missing."
        } 

        return ApiSvc.exec($scope, 'auth0/auth', {
          "pPersonID": profile.person_id ? profile.person_id : localStorage.getItem('personid'),
          "pEmail": profile.email,
          "pSkipEmail": !!localStorage.getItem('personid_from_auth0') ? 1 : 0
        }, true)
          .then(function (res) {
            ApiSvc.CheckIQXResult(res)
            loginSvc.setLoggedIn(res)
              .then(function () {
                var URLToNav = localStorage.getItem('goto')
                localStorage.removeItem('goto')
                localStorage.removeItem('personid')

                ApplicationSvc.postLoginRoute = '/'   // Reset the default
                $location.url(URLToNav)
              })
          })
          .catch(function (err) {
            if (angular.isObject(err) && err.status && err.status == 401) {
              $scope.loginerr = 'Invalid user name or password'
            } else {
              $scope.loginerr = ApiSvc.ExtractError(err)
            }
            $scope.isLoading = false
          })
      })
    }, 1000)

  })
